module.exports = __webpack_public_path__ + "static/media/dualBabyBlock.b0f680f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/dualBabyBlock.png
// module id = 600
// module chunks = 0